module.exports = __webpack_public_path__ + "static/media/reactjs.f8267b71.png";